import { useState } from "react";
import TemplatesTab from "./email-management/TemplatesTab";
import SequencesTab from "./email-management/SequencesTab";
import TriggersTab from "./email-management/TriggersTab";
import DistributionTab from "./email-management/DistributionTab";
import StatsTab from "./email-management/StatsTab";
import SendersTab from "./email-management/SendersTab";
import QueueTab from "./email-management/QueueTab";
import SuppressionTab from "./email-management/SuppressionTab";
import HealthTab from "./email-management/HealthTab";

const TABS = [
  { key: "templates",    label: "✉️ Templates" },
  { key: "sequences",    label: "🔁 Sequences" },
  { key: "triggers",     label: "⚡ Triggers" },
  { key: "distribution", label: "📋 Distribution" },
  { key: "stats",        label: "📊 Stats" },
  { key: "senders",      label: "📧 Senders" },
  { key: "queue",        label: "📬 Queue" },
  { key: "suppression",  label: "🚫 Suppression" },
  { key: "health",       label: "❤️ Health" },
] as const;

type TabKey = typeof TABS[number]["key"];

export default function EmailManagement() {
  const [tab, setTab] = useState<TabKey>("templates");

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-foreground mb-6">Email Management</h1>

      <div className="flex gap-1 mb-6 border-b overflow-x-auto">
        {TABS.map(({ key, label }) => (
          <button key={key} onClick={() => setTab(key)}
            className={`px-5 py-2.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${tab === key ? "border-blue-600 text-primary" : "border-transparent text-muted-foreground hover:text-foreground"}`}>
            {label}
          </button>
        ))}
      </div>

      <div className="bg-background rounded-lg border p-6">
        {tab === "templates"    && <TemplatesTab />}
        {tab === "sequences"    && <SequencesTab />}
        {tab === "triggers"     && <TriggersTab />}
        {tab === "distribution" && <DistributionTab />}
        {tab === "stats"        && <StatsTab />}
        {tab === "senders"      && <SendersTab />}
        {tab === "queue"        && <QueueTab />}
        {tab === "suppression"  && <SuppressionTab />}
        {tab === "health"       && <HealthTab />}
      </div>
    </div>
  );
}
